import { styled } from '@unfold/theme';

export const Svg = styled.svg`
  display: block;
  margin: auto;
  max-width: 100%;
  transform: rotate(-90deg)
`;

export const Circle = styled.circle`
  fill: none;
`;

export const CircleBackground = styled.circle`
  fill: none;
`;
